import { Language } from '../types/Language';
const getDisplayText = (key, textEn, textEs, language) => {
    if (language === Language.SPANISH) {
        return textEs[key];
    }
    return textEn[key];
};
export default getDisplayText;
